module.exports = "<div class=\"admin-groups\">\r\n\t<div class=\"add-group\">\r\n\t\t<input type=\"text\" name=\"name\" placeholder=\"Name\">\r\n\t\t<input type=\"number\" name=\"rank\" placeholder=\"Rank\">\r\n\t\t<button class=\"btn btn-sm btn-primary btn-add-group\">\r\n\t\t\tAdd Group\r\n\t\t</button>\r\n\t</div>\r\n\t<div class=\"edit-group\">\r\n\r\n\t</div>\r\n\t<div class=\"groups-list\">\r\n\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/admin-section/groups/groups.tpl.html
// module id = 75
// module chunks = 0